'use client'
import { Fragment, useState } from 'react'
import { Popover, Transition, Disclosure } from '@headlessui/react'
import Social from 'components/Social'

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const Menu = ({ nav, isLogged, setShowModal, fedId, clubId }) => {
  const [opened, setOpened] = useState(false)

  return (
    <>
      {/* MOBILE VIEW */}
      <div className="lg:hidden relative z-50 bg-blue shadow">
        <div
          className={`flex items-center justify-between mx-8 py-6 ${
            opened ? 'hidden' : 'block'
          }`}
        >
          <a href="/">
            <img
              src="/assets/logo-white.svg"
              className="object-cover"
              alt="logo"
            />
          </a>
          <img
            src="/assets/icons/menu-white.svg"
            className="w-10 mt-2 cursor-pointer"
            alt="menu"
            onClick={() => setOpened(true)}
          />
        </div>

        <div
          className={`h-screen w-full overflow-y-auto bg-blue ${
            opened ? 'fixed' : 'hidden'
          }`}
        >
          <div className="flex items-center justify-between mx-8 py-6">
            <a href="/">
              <img
                src="/assets/logo-white.svg"
                className="object-cover"
                alt="logo"
              />
            </a>
            <img
              src="/assets/icons/menu-white.svg"
              className="w-10 mt-2 cursor-pointer"
              alt="menu"
              onClick={() => setOpened(false)}
            />
          </div>
          <div className="grid grid-cols-1 justify-start m-10">
            {nav.map((_item, idx) => {
              const item = _item.attributes
              const children = item.children.data
              return children.length ? (
                <Disclosure
                  key={idx}
                  className="border-b border-white border-opacity-30 py-4"
                >
                  {({ open }) => {
                    return (
                      <div>
                        <Disclosure.Button className="w-full py-4 text-left text-[18px] text-white font-alliance-light border-b border-white border-opacity-30 outline-none">
                          <div className="flex items-center justify-between">
                            <p
                              className={`uppercase ${
                                open ? 'underline underline-offset-2' : null
                              }`}
                            >
                              {item.title}
                            </p>
                            <div>
                              {open ? (
                                <img
                                  src={`/assets/icons/arrow-simple-down.svg`}
                                  alt="icon"
                                  className="transition rotate-180 w-6 lg:w-10"
                                />
                              ) : (
                                <img
                                  src={`/assets/icons/arrow-simple-down.svg`}
                                  alt="icon"
                                  className="transition rotate-0 w-6 lg:w-10"
                                />
                              )}
                            </div>
                          </div>
                        </Disclosure.Button>

                        <Transition
                          as={Fragment}
                          enter="transition ease-out duration-100"
                          enterFrom="opacity-0 -translate-y-1"
                          enterTo="opacity-100 translate-y-0"
                          leave="transition ease-in duration-0"
                          leaveFrom="opacity-100 translate-y-0"
                          leaveTo="opacity-0 -translate-y-1"
                        >
                          <Disclosure.Panel className="ml-10">
                            <div>
                              <nav className="mt-1" aria-label="Sidebar">
                                {children.map((_subItem, subIdx) => {
                                  const subItem = _subItem.attributes
                                  const subItemChildren = subItem.children.data
                                  return !subItemChildren.length ? (
                                    <div
                                      key={subIdx}
                                      className="border-b border-white border-opacity-30"
                                    >
                                      <a
                                        href={subItem.url}
                                        className="w-full flex items-center text-white text-[18px] font-alliance-light py-4"
                                      >
                                        {subItem.title}
                                      </a>
                                    </div>
                                  ) : (
                                    <Disclosure
                                      as="div"
                                      key={subIdx}
                                      className="space-y-1"
                                    >
                                      {({ open }) => (
                                        <>
                                          <Disclosure.Button className="w-full py-4 text-left text-[18px] text-white font-alliance-light border-b border-white border-opacity-30 outline-none">
                                            <div className="flex items-center justify-between">
                                              <p
                                                className={`${
                                                  open
                                                    ? 'underline underline-offset-2'
                                                    : null
                                                }`}
                                              >
                                                {subItem.title}
                                              </p>
                                              <div>
                                                {open ? (
                                                  <img
                                                    src={`/assets/icons/arrow-simple-down.svg`}
                                                    alt="icon"
                                                    className="transition rotate-180 w-6 lg:w-10"
                                                  />
                                                ) : (
                                                  <img
                                                    src={`/assets/icons/arrow-simple-down.svg`}
                                                    alt="icon"
                                                    className="transition rotate-0 w-6 lg:w-10"
                                                  />
                                                )}
                                              </div>
                                            </div>
                                          </Disclosure.Button>

                                          <Transition
                                            as={Fragment}
                                            enter="transition ease-out duration-100"
                                            enterFrom="opacity-0 -translate-y-1"
                                            enterTo="opacity-100 translate-y-0"
                                            leave="transition ease-in duration-0"
                                            leaveFrom="opacity-100 translate-y-0"
                                            leaveTo="opacity-0 -translate-y-1"
                                          >
                                            <Disclosure.Panel className="ml-10">
                                              {subItemChildren.map(
                                                (_subSubItem, subSubIdx) => {
                                                  const subSubItem =
                                                    _subSubItem.attributes
                                                  return (
                                                    <Disclosure.Button
                                                      key={subSubIdx}
                                                      as="a"
                                                      href={
                                                        subSubItem.url || '/'
                                                      }
                                                      className="flex w-full items-center py-4 text-[18px] font-alliance-light text-white border-b border-white border-opacity-30 outline-none"
                                                    >
                                                      <p>{subSubItem.title}</p>
                                                    </Disclosure.Button>
                                                  )
                                                }
                                              )}
                                            </Disclosure.Panel>
                                          </Transition>
                                        </>
                                      )}
                                    </Disclosure>
                                  )
                                })}
                              </nav>
                            </div>
                          </Disclosure.Panel>
                        </Transition>
                      </div>
                    )
                  }}
                </Disclosure>
              ) : (
                <p
                  key={idx}
                  className="text-white font-alliance-light text-[18px] border-b border-white border-opacity-30 py-4 uppercase"
                >
                  <a href={item.url}>{item.title}</a>
                </p>
              )
            })}

            {/* <div>
              <p className="text-white text-[14px] mt-16 mb-2">BUSCAR</p>
              <div className="flex">
                <input
                  type="text"
                  name="search"
                  className="appearance-none text-[32px] md:text-[40px] text-white lg:text-[24px] placeholder-white placeholder:text-[32px] md:placeholder:text-[40px] placeholder:opacity-30 w-full bg-blue border-none"
                  placeholder="Què necessites?"
                />
                <img
                  src={`/assets/icons/arrow-circle-right-white.svg`}
                  alt="icon"
                  className="w-10"
                />
              </div>
              <p className="mt-3 border-b-2 border-white border-opacity-30"></p>
            </div> */}
            <p className="text-white font-alliance-light text-[18px] border-b border-white border-opacity-30 py-4 uppercase">
              {isLogged ? (
                <a
                  href={
                    clubId
                      ? '/privat/club/dades/principal'
                      : '/privat/federat/dades-personals'
                  }
                >
                  ÀREA PRIVADA
                </a>
              ) : (
                <button
                  onClick={() => {
                    if (!isLogged) {
                      setShowModal(true)
                    }
                  }}
                >
                  ÀREA PRIVADA
                </button>
              )}
            </p>
            <div className="mt-12">
              <Social />
            </div>
          </div>
        </div>
      </div>

      {/* DESKTOP VIEW */}
      <Popover.Group as="nav">
        <div className="hidden lg:block relative z-50 bg-blue shadow">
          <div className="flex items-center py-6">
            <div className="flex-none ml-6 xl:ml-12 2xl:ml-16">
              <a href="/">
                <img
                  src="/assets/logo-white.svg"
                  className="object-cover"
                  alt=""
                />
              </a>
            </div>
            <div className="flex grow justify-end">
              {nav.map((_item, idx) => {
                const item = _item.attributes
                const children = item.children.data
                return children.length ? (
                  <Popover key={idx}>
                    {({ open }) => {
                      return (
                        <>
                          <Popover.Button className="text-white font-alliance-light text-[14px] uppercase outline-none">
                            <span
                              className={`px-1 xl:px-4 2xl:px-8 hover:underline hover:underline-offset-2 ${
                                open ? 'underline underline-offset-2' : null
                              }`}
                            >
                              {item.title}
                            </span>
                          </Popover.Button>

                          <Transition as={Fragment}>
                            <Popover.Panel className="absolute z-10 pt-6 mt-[37px] bg-blue w-full left-0 pb-10 h-auto">
                              <div className="flex">
                                <div className="grid grow ml-6 xl:ml-12 2xl:ml-16 items-end">
                                  <div className="mr-4">
                                    <Social />
                                  </div>
                                </div>
                                <div className="flex-none w-[855px] xl:w-[1070px] 2xl:w-[1320px]">
                                  <nav aria-label="Sidebar">
                                    {children.map((_subItem, subIdx) => {
                                      const subItem = _subItem.attributes
                                      const subItemChildren =
                                        subItem.children.data
                                      return !subItemChildren.length ? (
                                        <div
                                          key={subIdx}
                                          className={classNames(
                                            subIdx === 0 ? 'border-y' : '',
                                            'border-b w-[250px] xl:w-[300px] 2xl:w-[350px]'
                                          )}
                                        >
                                          <a
                                            href={subItem.url}
                                            className="w-full flex items-center text-white text-[18px] font-alliance-light py-4 hover:underline hover:underline-offset-2"
                                          >
                                            {subItem.title}
                                          </a>
                                        </div>
                                      ) : (
                                        <Disclosure
                                          as="div"
                                          key={subIdx}
                                          className="space-y-1"
                                        >
                                          {({ open }) => (
                                            <div className="flex">
                                              <Disclosure.Button className="flex items-start py-4 text-left text-[18px] font-alliance-light border-b border-white w-[250px] xl:w-[300px] 2xl:w-[350px]">
                                                <span
                                                  className={`flex-1 text-white font-alliance-light text-[18px] hover:underline hover:underline-offset-2 ${
                                                    open
                                                      ? 'underline underline-offset-2'
                                                      : null
                                                  }`}
                                                >
                                                  {subItem.title}
                                                </span>
                                                <div className="pt-1">
                                                  {open ? (
                                                    <img
                                                      src={`/assets/icons/arrow-simple-right-white.svg`}
                                                      alt="icon"
                                                      className="transition rotate-180 w-3"
                                                    />
                                                  ) : (
                                                    <img
                                                      src={`/assets/icons/arrow-simple-right-white.svg`}
                                                      alt="icon"
                                                      className="transition rotate-0 w-3"
                                                    />
                                                  )}
                                                </div>
                                              </Disclosure.Button>
                                              <Disclosure.Panel className="">
                                                <div className="flex flex-wrap w-[600px] xl:w-[700px] 2xl:w-[800px] -mt-[1px]">
                                                  {subItemChildren.map(
                                                    (
                                                      _subSubItem,
                                                      subSubIdx
                                                    ) => {
                                                      const subSubItem =
                                                        _subSubItem.attributes
                                                      return (
                                                        <Disclosure.Button
                                                          key={subSubIdx}
                                                          as="a"
                                                          href={
                                                            subSubItem.url ||
                                                            '/'
                                                          }
                                                          className={`flex items-center w-[250px] xl:w-[300px] 2xl:w-[350px] py-4 ml-4 text-[18px] font-alliance-light text-white border-b hover:underline hover:underline-offset-2 ${
                                                            subSubIdx == 0 ||
                                                            subSubIdx == 1
                                                              ? 'border-t'
                                                              : null
                                                          }`}
                                                        >
                                                          {subSubItem.title}
                                                        </Disclosure.Button>
                                                      )
                                                    }
                                                  )}
                                                </div>
                                              </Disclosure.Panel>
                                            </div>
                                          )}
                                        </Disclosure>
                                      )
                                    })}
                                  </nav>
                                </div>
                              </div>
                            </Popover.Panel>
                          </Transition>
                        </>
                      )
                    }}
                  </Popover>
                ) : (
                  <p
                    key={idx}
                    className="text-white items-center font-alliance-light text-[14px] pt-[2px] px-1 xl:px-4 2xl:px-8 uppercase hover:underline hover:underline-offset-2"
                  >
                    <a href={item.url}>{item.title}</a>
                  </p>
                )
              })}
            </div>
            <div className="flex-none mr-2 lg:mr-6">
              <div className="flex">
                <div className="border-white border-l-2 lg:mx-2 xl:mx-6 2xl:mx-8 h-6"></div>
                {isLogged ? (
                  <a
                    href={
                      clubId
                        ? '/privat/club/dades/principal'
                        : '/privat/federat/dades-personals'
                    }
                    className="text-white pt-[2px] font-alliance-light text-[14px] uppercase mr-2 xl:mr-5 2xl:mr-6 hover:underline hover:underline-offset-2"
                  >
                    ÀREA PRIVADA
                  </a>
                ) : (
                  <button
                    className="text-white pt-[2px] font-alliance-light text-[14px] uppercase mr-2 xl:mr-5 2xl:mr-6 hover:underline hover:underline-offset-2"
                    onClick={() => {
                      if (!isLogged) {
                        setShowModal(true)
                      }
                    }}
                  >
                    ÀREA PRIVADA
                  </button>
                )}
                {/* <img
                  src={`/assets/icons/search.svg`}
                  alt="icon"
                  className="w-6 xl:mr-4 2xl:mr-10"
                /> */}
              </div>
            </div>
          </div>
        </div>
      </Popover.Group>
    </>
  )
}

export default Menu
